import { isFunction } from './lang';
export function performanceObserver() {
    return !!globalThis.PerformanceObserver;
}
export function performance() {
    return !!globalThis.performance;
}
export function performanceNow() {
    return isFunction(globalThis.performance?.now);
}
export function compressionStream() {
    return isFunction(globalThis.CompressionStream);
}
export function structuredClone() {
    return isFunction(globalThis.structuredClone);
}
export function webWorkers() {
    return !!globalThis.Worker;
}
export function webSockets() {
    return !!globalThis.WebSocket;
}
export function fetch(fetchable) {
    return isFunction((fetchable ?? globalThis)?.fetch);
}
